import {
	IHospitalScheduleModel,
	HospitalScheduleModel,
	ILicenseModel,
	IVeterinarianSignatureModel,
	LicenseModel,
	VeterinarianSignatureModel,
	schedule,
} from "@common/models";
import { computed, makeObservable, observable } from "mobx";
import { IModel } from "@common/models/Model";
import { petcoPewterBlue } from "@common/_assets/color-constants.js";

export interface IVeterinarianModel extends IModel {
	veterinarianId: number;
	title: string;
	firstName: string;
	lastName: string;
	email: string;
	username: string;
	schedulingColor: string;
	licenses: ILicenseModel[];
	activeSignature: IVeterinarianSignatureModel | undefined;
	schedulePreferences: schedule.EntitySchedulePreference[];
	hospitalSchedules: IHospitalScheduleModel[] | undefined;
	petcoUserId: string;
	fullName: string | undefined;
}

export class VeterinarianModel implements IVeterinarianModel {
	@observable rowVersion: string;
	@observable veterinarianId: number;
	@observable title: string;
	@observable firstName: string;
	@observable lastName: string;
	@observable email: string;
	@observable username: string;
	@observable schedulingColor: string;
	@observable activeSignature: VeterinarianSignatureModel | undefined;
	@observable licenses: LicenseModel[] = [];
	@observable hospitalSchedules: HospitalScheduleModel[] = [];
	@observable schedulePreferences: schedule.EntitySchedulePreference[] = [];
	@observable petcoUserId: string;
	@observable fullName: string | undefined;

	constructor(init?: Partial<IVeterinarianModel>) {
		this.rowVersion = _.defaultTo(init?.rowVersion, "");
		this.veterinarianId = _.defaultTo(init?.veterinarianId, 0);
		this.title = _.defaultTo(init?.title, "");
		this.firstName = _.defaultTo(init?.firstName, "");
		this.lastName = _.defaultTo(init?.lastName, "");
		this.email = _.defaultTo(init?.email, "");
		this.username = _.defaultTo(init?.username, "");
		this.schedulingColor = _.defaultTo(init?.schedulingColor, petcoPewterBlue);
		this.licenses = (init?.licenses ?? []).map(l => new LicenseModel(l));
		this.activeSignature = init?.activeSignature ? new VeterinarianSignatureModel(init.activeSignature) : undefined;
		this.hospitalSchedules = (init?.hospitalSchedules ?? []).map(sp => new HospitalScheduleModel(sp));
		this.schedulePreferences = (init?.schedulePreferences ?? []).map(sp => new schedule.EntitySchedulePreference(sp));
		this.petcoUserId = _.defaultTo(init?.petcoUserId, "");
		this.fullName = _.defaultTo(init?.fullName, "");

		makeObservable(this, undefined, { autoBind: true });
	}

	@computed get doctorTitle() {
		return `${this.title ? this.title + " " : ""}${this.firstName} ${this.lastName}`;
	}
}
